export const PRIMARY_COLOR = '#4B49AC';